<template>
  <div class="HandlingIncubation">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="入孵流程图" name="first">
        <div class="base-search">
          <el-upload
            v-if="tableData.length === 0"
            :action="this.uploadURL"
            name="file"
            :show-file-list="false"
            :before-upload="beforeAvatarUpload"
            :on-success="handlePictureCardPreview"
            :http-request="HouImgFile"
          >
            <el-button type="success" style="background: #623AA2; border: none;">
              上传流程图
            </el-button>
          </el-upload>
          <el-button
            type="success"
            v-else
            @click="addEvent"
            style="background: #623AA2; border: none;"
          >
            上传流程图
          </el-button>
        </div>
        <div class="base-table">
          <el-table
            ref="multipleTable"
            :data="tableData"
            style="width: 100%"
            :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }"
            class="table"
          >
            <el-table-column label="入孵流程图" align="center" prop="url">
              <template slot-scope="scope">
                <template v-if="tableData.length > 0 && scope.row.flowchartsSrc">
                  <img
                    :src="imgUrl + scope.row.flowchartsSrc"
                    alt=""
                    srcset=""
                    style="width: 1200px;height: 180px;"
                  />
                </template>
              </template>
            </el-table-column>
            <el-table-column
              label="创建时间"
              align="center"
              width="200"
              prop="createTime"
            ></el-table-column>
            <el-table-column label="操作" align="center" width="240px">
              <template slot-scope="scope">
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.$index, scope.row)"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="margin-top: 30px;float: left;width: 100%;text-align: left;">
          <el-row>
            <el-col :span="24">审核人设置</el-col>
          </el-row>
          <el-row style="margin: 20px 0 10px 0;">
            <el-col :span="24">
              <span style="margin-right: 15px;">一级审核人</span>
              <el-select
                v-model="firstReviewed"
                multiple
                @change="chengewed"
                placeholder="请选择"
                style="width: 360px;"
              >
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.username"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <span style="margin-right: 15px;">二级审核人</span>
              <el-select
                v-model="secondReviewed"
                multiple
                @change="chengewed"
                placeholder="请选择"
                style="width: 360px;"
              >
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.username"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-col>
          </el-row>
        </div>
      </el-tab-pane>
      <el-tab-pane label="入孵模板" name="second">
        <div class="base-search">
          <el-upload
            :action="this.uploadURL"
            name="file"
            :show-file-list="false"
            :before-upload="beforeHandlePreview"
            :on-success="handlePreview"
          >
            <el-button
              type="success"
              icon="el-icon-plus"
              style="background: #623AA2; border: none;"
            >
              上传模板
            </el-button>
          </el-upload>
          <el-button
            type="danger"
            icon="el-icon-delete"
            style="margin-left: 15px;"
            @click="deleteAll"
          >
            批量删除
          </el-button>
        </div>
        <div class="base-table">
          <el-table
            ref="multipleTable"
            :data="TempData"
            style="width: 100%"
            :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }"
            class="table"
            @selection-change="selectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>

            <el-table-column type="index" width="150" label="序号" align="center">
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column label="模板名称" align="center" prop="templateName"></el-table-column>
            <el-table-column label="创建时间" align="center" prop="createTime"></el-table-column>
            <el-table-column label="操作" align="center" width="240px">
              <template slot-scope="scope">
                <el-button
                  class="mini_btn"
                  size="mini"
                  type="danger"
                  @click="handleTempDelete(scope.$index, scope.row)"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
      <el-tab-pane label="线上审核" name="third">
        <div style="float: left;width: 100%;text-align: left;">
          <el-row style="margin: 20px;">
            <el-col :span="24">
              <span style="margin-right: 15px;">审核状态</span>
              <el-select
                v-model="examineStatus"
                @change="getUserincubation"
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="(item, index) in examineStatusOption"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-col>
          </el-row>
        </div>
        <div class="base-table">
          <el-table
            ref="multipleTable"
            :data="VerifyData"
            style="width: 100%"
            :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }"
            class="table"
          >
            <el-table-column type="index" width="150" label="序号" align="center">
              <template slot-scope="scope">
                <span>{{ scope.$index + (pageVO.page - 1) * pageVO.pageSize + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column label="企业名称" align="center" prop="companyName"></el-table-column>
            <el-table-column label="企业logo" align="center" prop="logo">
              <template slot-scope="scope" v-if="scope.row.logo">
                <img
                  :src="imgUrl + scope.row.logo"
                  alt=""
                  srcset=""
                  style="width: 45px;height: 60px;"
                />
              </template>
            </el-table-column>
            <!-- <el-table-column label="审核表单" align="center" prop="examineForm"></el-table-column> -->
            <el-table-column label="申请人" align="center" prop="creatorName"></el-table-column>
            <el-table-column label="申请时间" align="center" prop="applicantTime"></el-table-column>
            <el-table-column label="审核状态" align="center" prop="examineStatus">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.examineStatus == 1">审核中</el-tag>
                <el-tag v-else-if="scope.row.examineStatus == 2" type="success">通过</el-tag>
                <el-tag v-else-if="scope.row.examineStatus == 3" type="danger">驳回</el-tag>
                <!-- <span style="font-size: 12px;" v-if="scope.row.examineStatus == 1">审核中</span>
                <span style="font-size: 12px;"  v-else-if="scope.row.examineStatus == 2">通过</span>
                <span style="font-size: 12px;"  v-else-if="scope.row.examineStatus == 3">驳回</span>
                <br/><span style="font-size: 12px;" v-if="scope.row.node == 2 && scope.row.examineStatus == 1">(一级审核人已审核)</span> -->
              </template>
            </el-table-column>
            <!-- <el-table-column
              label="审核备注"
              align="center"
              prop="applicantRemark"
            ></el-table-column> -->
            <el-table-column label="操作" align="center" width="290px">
              <template slot-scope="scope">
                <el-button class="mini_btn" size="mini" @click="details(scope.row)">
                  详情
                </el-button>
                <el-button class="mini_btn" size="mini" @click="download(scope.row)">
                  下载入孵申请表
                </el-button>
                <el-button
                  class="mini_btn"
                  size="mini"
                  v-if="firstReviewedble(scope.row)"
                  @click="passThrough(scope.$index, scope.row, 2)"
                >
                  通过
                </el-button>
                <el-button
                  class="mini_btn"
                  size="mini"
                  v-if="firstReviewedble(scope.row)"
                  @click="passThrough(scope.$index, scope.row, 3)"
                >
                  驳回
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="pageVO.page"
            :page-size="pageVO.pageSize"
            layout="total,prev, pager, next"
            :total="total"
            style="text-align:left;margin:20px 0"
          ></el-pagination>
        </div>
        <!-- <el-pagination @current-change="handleCurrentChange" :current-page.sync="current_page" :page-size="per_page" layout="total,prev, pager, next"
		 :total="total" style="text-align:left;margin:20px 0"></el-pagination> -->
      </el-tab-pane>
    </el-tabs>
    <el-dialog
      @closed="closed"
      title="提示"
      center
      :visible.sync="remarkVisible"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <el-form :model="remarkform" ref="ruleForm" label-width="120px" :rules="siteFormRule">
        <el-row style="margin: 20px 0 10px 0;">
          <el-form-item
            label="审批备注"
            :prop="(remarkform.examineStatus === 2 ? 'is' : '') + 'applicantRemark'"
          >
            <el-input
              type="textarea"
              :rows="1"
              v-model="remarkform.applicantRemark"
              placeholder="请输入审批备注"
            ></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closed">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
     <!-- 上传弹框 -->
     <UploadDialog :visibleUpload="visibleUpload" :updateItem="updateItem" @onClose="uploadClose" />
  </div>
</template>
<script>
import { async } from 'q';

import UploadDialog from './components/uploadDialog.vue';
import Cookies from 'js-cookie'
export default {
  data() {
    return {
      visibleUpload:false,
      activeName: 'first',
      tableData: [],
      firstReviewed: [],
      secondReviewed: [],
      options: [],
      TempData: [],
      pageVO: {
        pageSize: 10,
        page: 1
      },
      total: 0,
      filename: null,
      deleteRow: [],
      VerifyData: [],
      remarkVisible: false,
      remarkform: {},
      updateItem:{},
      siteFormRule: {
        applicantRemark: [
          {
            required: true,
            message: '请输入审批备注',
            trigger: 'blur'
          }
        ]
      },
      examineStatus: null,
      examineStatusOption: [
        {
          label: '审核中',
          value: 1
        },
        {
          label: '通过',
          value: 2
        },
        {
          label: '驳回',
          value: 3
        }
      ]
    };
  },
  components:{
    UploadDialog
  },
  created() {
    this.getData(); //获取入孵流程图
    this.getDataid(); //获取入孵流程图
    this.getUserData(); // 获取用户列表
    this.getUserTempData(); // 获取模板列表
    this.getUserincubation(); // 获取线上审核
  },
  computed:{
    firstReviewedble(){
      return function(params) {
        if(params.firstReviewedStatus === 1){
          if(this.firstReviewed.includes(JSON.parse(Cookies.get('userInfo')).id) || this.firstReviewed.includes(JSON.parse(Cookies.get('userInfo')).id+'')){
            return true
          }else{
            return false
          }
        }else if(params.firstReviewedStatus === 2 && params.secondReviewedStatus === 1){
          if(this.secondReviewed.includes(JSON.parse(Cookies.get('userInfo')).id) || this.secondReviewed.includes(JSON.parse(Cookies.get('userInfo')).id+'')){
            return true
          }else{
            return false
          }
        }
            return false
        // console.log(this.firstReviewed);
        // console.log(this.secondReviewed);
        // // this.firstReviewed // 一级审核人
        // // this.secondReviewed // 二级审核人
        // console.log(this.$store.getters.userId);
        // console.log(params.secondReviewedStatus);//第二审核人 1 中 2 通过 3 驳回
        // console.log(params.firstReviewedStatus);//第一审核人
        // return false
      }
    }
  },
  methods: {
    getDataid() {
      this.http
        .get(
          this.urlConfig.devUrl + 'apij2/admin-api/voucher/incubation-online-flowcharts/get?id=1'
        )
        .then(res => {
          if (res.code == 0 && res.data) {
            // console.log(res);
            this.firstReviewed = res.data.firstReviewed
              ? res.data.firstReviewed.split(',').map(Number)
              : [];
            this.secondReviewed = res.data.secondReviewed
              ? res.data.secondReviewed.split(',').map(Number)
              : [];
            // this.options = res.data.data;
          }
        });
    },
    getData() {
      this.http
        .get(
          this.urlConfig.devUrl + 'apij2/admin-api/voucher/incubation-online-flowcharts/getModule'
        )
        .then(res => {
          if (res.code == 0 && res.data) {
            this.tableData = [res.data];
          } else {
            this.tableData = [];
          }
        });
    },
    getUserData() {
      this.http.get(`User?type=2&is_page=1&all=1`).then(res => {
        if (res.code == 0) {
          this.options = res.data.data;
        }
      });
    },
    getUserTempData() {
      this.http
        .post(this.urlConfig.devUrl + 'apij2/admin-api/voucher/incubation-online-flowcharts/page', {
          is_page: 1,
          type: 2
        })
        .then(res => {
          if (res.code == 0) {
            this.TempData = res.data.data;
          }
        });
    },
    // 切换tab
    handleClick() {},
    addEvent() {
      // 新增流程图
      if (this.tableData.length > 0) {
        this.$message({
          message: '请删除流程图后新增',
          type: 'warning'
        });
        return false;
      } else {
        return true;
      }
    },
    handlePictureCardPreview(file) {
      this.http
        .post(
          this.urlConfig.devUrl + 'apij2/admin-api/voucher/incubation-online-flowcharts/create',
          {
            flowchartsSrc: file,
            type: 1,
            creatorName: JSON.parse(this.$store.getters.userInfo).name,
            updaterName: JSON.parse(this.$store.getters.userInfo).name
          }
        )
        .then(res => {
          this.$message({
            type: 'success',
            message: '新增成功'
          });
          this.getData();
        });
    },
    chengewed() {
      this.http
        .put(
          this.urlConfig.devUrl + 'apij2/admin-api/voucher/incubation-online-flowcharts/update',
          {
            id: 1,
            firstReviewed: this.firstReviewed.join(','),
            secondReviewed: this.secondReviewed.join(','),
            creatorName: JSON.parse(this.$store.getters.userInfo).name,
            updaterName: JSON.parse(this.$store.getters.userInfo).name
          }
        )
        .then(res => {
          this.$message({
            type: 'success',
            message: '修改成功'
          });
          this.getDataid();
        });
    },
    getUserincubation() {
      this.http
        .post(this.urlConfig.devUrl + 'apij2/admin-api/voucher/incubation-online-examine/page', {
          ...this.pageVO,
          examineStatus: this.examineStatus
        })
        .then(res => {
          if (res.code == 0) {
            this.VerifyData = res.data.data;
            console.log(res.data.data);
            this.total = res.data.total;
          }
        });
    },
    beforeAvatarUpload(file) {
      let type = false;
      if (
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/jpg' ||
        file.type === 'image/gif' ||
        file.type === 'image/bmp'
      ) {
        type = true;
      }
      if (!type) {
        this.$message.error('上传模板只能是 JPEG/jpg/png/gif/bmp 格式!');
      }
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 10MB!');
      }
      return type && isLt2M;
    },
    // 删除流程图
    handleDelete(index, item) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then(() => {
          this.http
            .request(
              this.urlConfig.devUrl + 'apij2/admin-api/voucher/incubation-online-flowcharts/delete',
              {
                ids: [item.id]
              },
              'delete'
            )
            .then(res => {
              if (res.code == 0) {
                this.$message({
                  type: 'success',
                  message: '删除成功'
                });
                this.getData();
              } else {
                this.$message({
                  message: '失败！',
                  type: 'error'
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    beforeHandlePreview(file) {
      this.filename = file.name.split('.')[0];
      return true;
    },
    handlePreview(e) {
      this.http
        .post(
          this.urlConfig.devUrl + 'apij2/admin-api/voucher/incubation-online-flowcharts/create',
          {
            flowchartsSrc: e.data.store_result,
            type: 2,
            templateName: this.filename,
            creatorName: JSON.parse(this.$store.getters.userInfo).name,
            updaterName: JSON.parse(this.$store.getters.userInfo).name
          }
        )
        .then(res => {
          if (res.code == 0) {
            this.$message({
              type: 'success',
              message: '上传成功'
            });
            this.getUserTempData();
          }
        });
    },
    //选择页码
    handleCurrentChange(e) {
      // console.log(e);
      this.pageVO.page = e;
      this.getUserincubation();
    },
    //上传照片墙
    HouImgFile(e) {
      var files = e.file;
      if (!files) return;
      this.createImage1(files, e, 'HouImg');
    },
    //其他图片上传
    createImage1(file, e, Name) {
      //lrz压缩
      // lrz图片先压缩在加载、
      lrz(file, {
        quality: 1
      })
        .then(rst => {
          this.http
            .post('/file/base64_upload', {
              image: rst.base64
            })
            .then(res => {
              this.handlePictureCardPreview(res.data);
              // this.url = res.data;
            });
          return rst;
        })
        .always(() => {
          // 清空文件上传控件的值
          e.target.value = null;
        });
    },
    addTemp() {
      // 上传模板
    },
    deleteAll() {
      // 批量删除模板
      if (this.deleteRow) {
        this.$confirm('此操作将批量删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        })
          .then(() => {
            this.http
              .request(
                this.urlConfig.devUrl +
                  'apij2/admin-api/voucher/incubation-online-flowcharts/delete',
                {
                  ids: this.deleteRow
                },
                'delete'
              )
              .then(res => {
                if (res.code == 0) {
                  this.$message({
                    type: 'success',
                    message: '删除成功'
                  });
                  this.getUserTempData();
                } else {
                  this.$message({
                    message: '失败！',
                    type: 'error'
                  });
                }
              });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
      } else {
        this.$message({
          type: 'warning',
          message: '请选择删除的记录'
        });
      }
    },
    selectionChange(selection) {
      this.deleteRow = [];
      if (selection.length != 0) {
        let arr = [];
        selection.forEach(item => {
          arr.push(item.id);
        });
        this.deleteRow = arr;
      }
    },
    handleTempDelete(index, item) {
      // 删除模板
      this.http
        .request(
          this.urlConfig.devUrl + 'apij2/admin-api/voucher/incubation-online-flowcharts/delete',
          {
            ids: [item.id]
          },
          'delete'
        )
        .then(res => {
          if (res.code == 0) {
            this.$message({
              type: 'success',
              message: '删除成功'
            });
            this.getUserTempData();
          }
        });
    },
    details(item){
      this.http
        .request(
          this.urlConfig.devUrl + 'apij2/admin-api/voucher/incubation-online-examine/get?id='+item.id,
          'get'
        )
        .then(res => {
      this.updateItem = res.data
      this.visibleUpload = true;
    })
    },
    uploadClose(){
      this.visibleUpload = false;
    }, 
    download(item) {
      var array = []
      if(item.makerTeamSrc){
        array.push(item.makerTeamSrc)
      }
      if(item.incubationAgreementSrc){
        array.push(item.incubationAgreementSrc)
      }
      if(item.entrepreneurNameSrc){
        array.push(item.entrepreneurNameSrc)
      }
      console.log(array);
      for (var i = 0; i < array.length; i++) {
          const iframe = document.createElement('iframe');
          iframe.style.display = 'none'; // 防止影响页面
          iframe.style.height = 0; // 防止影响页面
          iframe.src = this.imgUrl + JSON.parse(array[i])[0].url;
          // iframe.src = this.imgUrl + JSON.parse(item.flowchartsSrc)[i].store_result;
          // console.log("urls[i]==", i, urls[i])
          document.body.appendChild(iframe); // 这一行必须，iframe挂在到dom树上才会发请求
          // 5分钟之后删除（onload方法对于下载链接不起作用，就先抠脚一下吧）
          setTimeout(() => {
            iframe.remove();
          }, 5 * 60 * 1000);
        }
      return
      console.log(item.flowchartsSrc);
      if (Object.getPrototypeOf(item.flowchartsSrc) === Object.prototype) {
        var a = document.createElement('a');
        a.href = this.imgUrl + JSON.parse(item.flowchartsSrc).store_result;
        a.download = item.examineForm;
        a.click();
      } else {
        // JSON.parse(item.flowchartsSrc).forEach(async el=>{
        //   await this.downLo(this.imgUrl + el.store_result)
        // })
        for (var i = 0; i < JSON.parse(item.flowchartsSrc).length; i++) {
          const iframe = document.createElement('iframe');
          iframe.style.display = 'none'; // 防止影响页面
          iframe.style.height = 0; // 防止影响页面
          iframe.src = this.imgUrl + JSON.parse(item.flowchartsSrc)[i].store_result;
          // console.log("urls[i]==", i, urls[i])
          document.body.appendChild(iframe); // 这一行必须，iframe挂在到dom树上才会发请求
          // 5分钟之后删除（onload方法对于下载链接不起作用，就先抠脚一下吧）
          setTimeout(() => {
            iframe.remove();
          }, 5 * 60 * 1000);
        }
      }
    },
    async downLo(url) {
      var a = document.createElement('a');
      a.href = url;
      a.click();
    },
    getBolb(url) {
      return new Promise(resolve => {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.responseType = 'blob';
        xhr.onload = () => {
          if (xhr.status === 200) {
            resolve(xhr.response);
          }
        };
        xhr.send();
      });
    },
    saveAs(blob, filename) {
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, filename);
      } else {
        const link = document.createElement('a');
        const body = document.querySelector('body');

        link.href = window.URL.createObjectURL(blob);
        link.download = filename;

        // fix Firefox
        link.style.display = 'none';
        body.appendChild(link);

        link.click();
        body.removeChild(link);

        window.URL.revokeObjectURL(link.href);
      }
    },
    passThrough(index, item, num) {
      this.remarkVisible = true;
      this.remarkform = {
        id: item.id,
        node: item.node,
        examineStatus: num,
        applicantRemark: null
      };
    },
    // 关闭提交
    closed() {
      this.remarkform = {};
      this.remarkVisible = false;
    },
    submitForm() {
      this.http
        .put(
          this.urlConfig.devUrl + 'apij2/admin-api/voucher/incubation-online-examine/approval',
          this.remarkform
        )
        .then(res => {
          if (res.code == 0) {
            this.$message({
              type: 'success',
              message: '操作成功'
            });
            this.closed();
            this.getUserincubation();
          }
        });
    }
  }
};
</script>
<style scope lang="scss">
.bordernone span {
  border: none !important;
}
.base-search {
  width: 100%;
  text-align: left;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.base-table {
  width: 100%;
  margin-top: 20px;
  border: 1px solid #eef1f6;
}
</style>
